// eslint-disable-next-line es/no-classes
export class AuthError extends Error {
    constructor(message = 'User is not logged in') {
        super(message);
        this.name = 'AuthError';
    }
}
